import { Component, ViewChild,  ElementRef, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { AddProductDialogComponent } from '../add-product-dialog/add-product-dialog.component';

import * as XLSX from 'xlsx';

import { PriceDialogComponent } from '../price-dialog/price-dialog.component'; 

import { TextDescriptionDialogComponent } from '../text-description-dialog/text-description-dialog.component'; 
import { AudioDescriptionDialogComponent } from '../audio-description-dialog/audio-description-dialog.component'; 
import { QrCodeDescriptionDialogComponent } from '../qr-code-description-dialog/qr-code-description-dialog.component'; 
import { PhotoDialogComponent } from '../photo-dialog/photo-dialog.component'; 

import { GestockService } from '../services/gestock.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

 
import { MatSnackBar } from '@angular/material/snack-bar';

import { DepotDialogComponent } from '../depot-dialog/depot-dialog.component';

import { CartComponent } from '../cart/cart.component';


import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-vente',
  templateUrl: './vente.component.html',
  styleUrls: ['./vente.component.css']
})
export class VenteComponent implements OnInit {

  searchTerm: string = '';
  page: number = 1;

  choosedDepot : any ;

    productYeupp = [] ;

  itemsPerPage = 25;
  currentPage = 1;


    products : any ; 

    openIt = 0 ;

    jobencours

    templateProduct = {
              id: 0,
              name: '',
              quantity: {
                qteTotal: 0,
                stocksParDepot: [
                ]
              },
              entryPrice: 0,
              salePrice: 0,
              prices: { gros: 0, demiGros: 0, detail: 0 },
              category: '',
              description: '',
              audioUrl: '',
              imageUrl: '',
              stockIn: 0,
              stockOut: 0
          } ;


  leStock : any ;

  previewProducts: any[] = [];

  selectedProducts: any[] = [];

  categories: string[] = [] ; //['Accessoires', 'Pièces détachées', 'Motos' ];

  newCategory: string = '';

  showSearch = false;
  showFilter = false;
  selectedCategories: string[] = [];

  samacaabiyoonwii = "" ;
  porteeUser : any = "" ;

  retourClientWS : any ;


  qtecommandee : any ;

  makepost = 0 ;

  allPoints = [] ;
  tousLesDepots = [] ;
  choosedPoint : any ;


  clients = [
    { id: 1, name: 'Client A' },
    { id: 2, name: 'Client B' },
    { id: 3, name: 'Client C' }
  ];

  selectedClient: any = null;

  cart: any[] = [];

  @ViewChild('qteDialog') qteDialog: TemplateRef<any>;
  qteDialoggRef : any ;
  choosenElt : any;


  prixEdite = undefined ;


  allQtsOnCart = [] ;
  panier = [] ;
  nbreligne = 0 ;
  ajoutpanier = false ;

  cartIDs = [] ;

  showpanier = false ;

  choosedACustomer = false ;

  qteCtrl: any ;

  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';


  leClient : any;

  displayedColumns: string[] = ['ref', 'designation', 'qteStock', 'cmup', 'gros', 'demiGros', 'detail'];


  @ViewChild('fileInput') fileInput!: ElementRef;

  @ViewChild('spinnerDialog', { static: false }) spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;


  @ViewChild('stockAdjustIn', { static: false }) stockAdjustInDialog: TemplateRef<any>;
  stockAdjustInDialogRef : any ;
  clientSelectionne: any = null;

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar,
        private configServer: GestockService,  private viewContainerRef: ViewContainerRef) { }

  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.porteeUser =  sessionStorage.getItem("portee") ;

    this.getAllPoints(); 
  }

  getAllPoints(){
    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
        this.boutiques = this.retourClientWS.data ; 
        if(this.boutiques.length==1)
          this.selectedBoutique = this.boutiques[0].idPoint ;
        this.getAllCategories() ;
            
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  onClientValide(data: any) {
    this.clientSelectionne = data;
    console.log('Client validé :', data);
  }

  genererFacture() {
    console.log('Générer la facture pour le client', this.clientSelectionne);
    // Logique de génération PDF ici
  }

  //////////////////////////////////////////////////////////////////
  /// 

  addPreviewedProducts() {
    this.openSpinnerDialog() ;
    this.configServer.addProductMasse(this.samacaabiyoonwii, this.previewProducts, this.choosedPoint.nompoint, "", "").then( (retourbi) => {
      this.closeSpinnerDialog();
      this.retourClientWS = retourbi ;
      console.log(this.retourClientWS.data) ;

      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.previewProducts = [];
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        

    /*this.previewProducts.forEach((product) => {
      this.products.push(product);
    });
    this.previewProducts = [];*/
  }

  adjustInventory() {
      console.log("Ajuster Inventaire !!! ") ;
  }

  getAllCategories(){
    this.configServer.getAllCategories(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      this.getsamastock() ;        
      console.log(this.retourClientWS.data) ;
      this.getAllPointsEtDepots() ;

      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        for (var i = 0; i < this.retourClientWS.data.length; i++) {
          this.categories.push(this.retourClientWS.data[i].nomcategorie)  ;
        }
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }


  getsamastock(){
    this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {      
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.leStock = this.retourClientWS.data ;
        this.getTheProducts() ;
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }

  reloadStock(){
    this.openSpinnerDialog() ;      
    this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {      
      this.closeSpinnerDialog() ;      
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.leStock = this.retourClientWS.data ;
        this.getTheProducts() ;
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }

  getAllPointsEtDepots(){
    this.configServer.getAllPointsEtDepots(this.samacaabiyoonwii, "thesklfd").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log("DEpotYI: ", this.retourClientWS.data) ;
      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ;
        this.retenirJusteLesDepots() ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  validateQuantity() {
    const min = 1;
    const max = this.choosedDepot.qteEnStock;
    if (this.qtecommandee < min) {
      this.qtecommandee = min;
    } else if (this.qtecommandee > max) {
      this.qtecommandee = max;
    }

    console.log(this.qtecommandee) ;
  }

  unsetPrice = false ;     

  openReglementDialog(element) {
    this.qtecommandee = 1 ;
    this.choosenElt = element ;
    this.choosedDepot = undefined ;
    this.prixEdite = this.getClientPrice(element.prices) ;

    if(this.prixEdite==0)
      this.unsetPrice = true ;
    else
      this.unsetPrice = false ;

    this.qteCtrl = new FormControl(null, [
      Validators.min(1),
      Validators.max(this.choosenElt.quantity.qteTotal)
    ]);
    this.qteDialoggRef = this.dialog.open(this.qteDialog,{
        height: '100vh'
      });
  }

  closeReglementDialog() {
    this.ajouterALaCommande(this.choosenElt, this.qtecommandee);
    this.qteDialoggRef.close();
  }


  onLieuxStructChange(event){
    this.choosedPoint = this.tousLesDepots[event.value] ;    
  }


  onDepotChange(event){
    console.log(this.choosenElt.quantity.stocksParDepot[event.value]);
    this.choosedDepot = this.choosenElt.quantity.stocksParDepot[event.value] ;    
  }



  retenirJusteLesDepots(){
    for (var i = 0; i < this.allPoints.length; i++) {
      if(this.allPoints[i].type=="Depot"){
        this.tousLesDepots.push(this.allPoints[i]) ;
      }
    }
  }


  getTheProducts(){
    this.products = [] ;
    let allNames = [] ;
    for (var i = 0; i < this.leStock.length; i++) {
      let indexouArticleBi = allNames.indexOf(this.leStock[i].nom_article) ;
      if(indexouArticleBi==-1){
        this.updateTheLineInfos(this.products.length, this.leStock[i], 1) ;
        allNames.push(this.leStock[i].nom_article) ;
      }else{
        this.updateTheLineInfos(indexouArticleBi, this.leStock[i], 2) ;
      }
    }
  }

  updateTheLineInfos(indexToUpdt, LaLigneEnStock, act){
    //act : 1==creation Nouvelle, 2==Mise à jour
    if(act==1){
      let baseElt = {
                id: 0,
                name: '',
                quantity: {
                  qteTotal: 0,
                  stocksParDepot: [
                  ]
                },
                entryPrice: 0,
                salePrice: 0,
                prices: { gros: 0, demiGros: 0, detail: 0 },
                category: '',
                description: '',
                audioUrl: '',
                imageUrl: '',
                stockIn: 0,
                stockOut: 0,
                detailsarticle : undefined
              } ;
      this.products.push(baseElt) ;
    }

    this.products[indexToUpdt].id = LaLigneEnStock.article_id ;
    this.products[indexToUpdt].name = LaLigneEnStock.nom_article ;

    this.products[indexToUpdt].quantity.qteTotal += LaLigneEnStock.qte_en_stock ;
    this.products[indexToUpdt].quantity.stocksParDepot.push({"nomDepot":LaLigneEnStock.depot_nom, 
                                 "qteEnStock":LaLigneEnStock.qte_en_stock,
                                 "idstock":LaLigneEnStock.id}) ;

    this.products[indexToUpdt].entryPrice = LaLigneEnStock.cmup ;
    this.products[indexToUpdt].prices = JSON.parse(LaLigneEnStock.prixvente) ;
    this.products[indexToUpdt].category = LaLigneEnStock.categorie ;
    this.products[indexToUpdt].description = JSON.parse(LaLigneEnStock.detailsarticle).description ;
    this.products[indexToUpdt].audioUrl = JSON.parse(LaLigneEnStock.detailsarticle).audioUrl ;
    this.products[indexToUpdt].imageUrl = JSON.parse(LaLigneEnStock.detailsarticle).imageUrl ;

    this.products[indexToUpdt].detailsarticle = JSON.parse(LaLigneEnStock.detailsarticle) ;
  }


  onCategorieChange(cat){
    if( !this.selectedCategories.includes(cat))
      this.selectedCategories.push(cat) ;
    else{
      let index = this.selectedCategories.indexOf(cat) ;
      this.selectedCategories.splice(index, 1); ;
    }
    this.onCategChoose(event) ;
  }

  inSelectedCategs(cat){
   return  this.selectedCategories.includes(cat) ; 
  }


  openAddProductDialog() {
    const dialogRef = this.dialog.open(AddProductDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.products.push(result); // Ajoute le produit à la liste
      }
    });
  }


  openPriceDialog(product: any) {
    const dialogRef = this.dialog.open(PriceDialogComponent, {
      width: '350px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        product.prices = result; // Remplace les prix s’ils ont été modifiés
      }
    });
  }


  openTextDescriptionDialog(product: any) {
    const dialogRef = this.dialog.open(TextDescriptionDialogComponent, {
      width: '400px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.description !== undefined) {
        product.description = result.description;
        this.updateProductInStock(product);
      this.showSuccessSnackBar('Description mise à jour avec succès.');
      }
    });
  }

  openAudioDescriptionDialog(product: any) {
    const dialogRef = this.dialog.open(AudioDescriptionDialogComponent, {
      width: '400px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.audioUrl !== undefined) {
        product.audioUrl = result.audioUrl;
        this.updateProductInStock(product);
      this.showSuccessSnackBar('Description Audio mise à jour avec succès.');
      }
    });
  }

  openQrCodeDialog(product: any) {
    this.dialog.open(QrCodeDescriptionDialogComponent, {
      width: '300px',
      data: { product }
    });
  }

  openPhotoDialog(product: any) {
    const dialogRef = this.dialog.open(PhotoDialogComponent, {
      width: '500px',
      data: { product }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.imageUrl !== undefined) {
        product.imageUrl = result.imageUrl;
        this.updateProductInStock(product);
        this.showSuccessSnackBar('Photo mis à jour avec succès.');
      }
    });
  }

  triggerFileUpload() {
    this.fileInput.nativeElement.click(); // Ouvre l'explorateur de fichiers
  }

  handleFileUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
  
      // Convertir les données en objets conformes au modèle attendu
      this.previewProducts = jsonData.map((item: any) => ({
        ref: item['REFERENCE'] || 'Produit sans nom',
        designation: item['DESIGNATION'] ?? 0,
        qteStock: item['QTE STOCK'] ??  item[' QTE STOCK '] ?? 0,
        cmup: item['PR CMUP'] ?? item[' PR CMUP '] ?? 0,
        gros: item['PV EN GROS'] || 'Autre',
        demiGros: item['DEMI GROS'] || '',
        detail: item['DETAIL'] ?? 0,
        audioUrl: '',  // Laisse vide car il n'y a pas d'importation d'audio
        imageUrl: '',  // Laisse vide car il n'y a pas d'importation d'audio
      }));

      this.closestockAdjustInDialog() ;
      console.log(this.previewProducts); // Vérifie que les données sont bien formatées
    };
    reader.readAsArrayBuffer(file);
  }


  retrieveInfoFromCustomerInfo(event){
    if(event!=undefined){
      this.choosedACustomer = true ;
      this.leClient = event ;
      this.showpanier = true ;

      setTimeout(() => {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;

        if (currentScroll > 100) { // Seuil : 100px, tu peux ajuster
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  }

  backToCustomerEdition(){
    this.choosedACustomer=false ;    
  }


  toggleSearch() {
    this.showSearch = !this.showSearch;
    this.showFilter = false; // Cache le filtre si on affiche la recherche
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
    this.showSearch = false; // Cache la recherche si on affiche les filtres
  }

  getUniqueCategories(): string[] {
    const categories: string[] = [];
    this.products.forEach(product => {
      if (!categories.includes(product.category)) {
        categories.push(product.category);
      }
    });
    return categories;
  }


  updateProductInStock(updatedProduct: any) {
    const index = this.products.findIndex(p => p.id === updatedProduct.id);
    if (index !== -1) {
      this.products[index] = { ...updatedProduct };
    }

    console.log("UPDATED PRODUCT") ;
    console.log(this.products[index]) ;
    
    // Si tu utilises un backend ou stockage local, ajoute ça :
    // this.stockService.save(this.products);
  }



  //get filteredProducts() {
  get filteredProducts() {
    return this.products.filter(product => {
      const matchesSearch = this.searchTerm === '' || product.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
      return matchesSearch && matchesCategory;
    });
  }


  get paginatedProducts() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.filteredProducts.slice(start, end);
  }


  onCategChoose(event){
    this.currentPage = 1;
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm = filterValue.trim().toLowerCase();
  }


  showSuccessSnackBar(message: string) {
    this.snackBar.open(message, 'Fermer', {
      duration: 600,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar']
    });
  }

  toggleSelection(product: any) {
    const index = this.selectedProducts.indexOf(product);
    if (index === -1) {
      this.selectedProducts.push(product);
    } else {
      this.selectedProducts.splice(index, 1);
    }
  }

  isSelected(product: any): boolean {
    return this.selectedProducts.includes(product);
  }


  toggleSelectAll() {
    if (this.areAllSelected()) {
      this.selectedProducts = [];
    } else {
      this.selectedProducts = [...this.filteredProducts];
    }
  }

  areAllSelected(): boolean {
    return this.selectedProducts.length === this.filteredProducts.length;
  }

  changeCategoryForSelected() {
    if (this.newCategory) {
      this.mettreAjourCategArtMasse() ;
    }
  }

  mettreAjourCategArtMasse(){
    this.openSpinnerDialog() ;
    this.configServer.mettreAjourCategArtMasse(this.samacaabiyoonwii, this.selectedProducts, this.newCategory).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.selectedProducts.forEach(product => {
          product.category = this.newCategory;
        });
        this.selectedProducts = []; // Reset après changement
        this.newCategory = '';
        //this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        //this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }


  applyCollectiveChange() {
    this.selectedProducts.forEach(product => {
      // Exemple : changer le prix de vente
      product.salePrice += 10; // ou ouvrir un dialog pour définir la nouvelle valeur
    });
  }

  openAddDepotDialog(product: any) {
    const dialogRef = this.dialog.open(DepotDialogComponent, {
      data: { mode: 'add', product },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        product.quantity.stocksParDepot.push(result);
        this.updateQteTotal(product);
        this.snackBar.open('Dépôt ajouté', 'Fermer', { duration: 2000 });
      }
    });
  }

  openEditDepotDialog(product: any, depot: any) {
    const dialogRef = this.dialog.open(DepotDialogComponent, {
      data: { mode: 'edit', product, depot },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        Object.assign(depot, result);
        this.updateQteTotal(product);
        this.snackBar.open('Dépôt modifié', 'Fermer', { duration: 2000 });
      }
    });
  }

  removeDepot(product: any, depot: any) {
    product.quantity.stocksParDepot = product.quantity.stocksParDepot.filter(d => d !== depot);
    this.updateQteTotal(product);
    this.snackBar.open('Dépôt supprimé', 'Fermer', { duration: 2000 });
  }

  updateQteTotal(product: any) {
    product.quantity.qteTotal = product.quantity.stocksParDepot
      .reduce((acc: number, d: any) => acc + Number(d.qteEnStock || 0), 0);
  }


  // Fonction de mise à jour du stock (entrée et sortie)
  updateStock(product: any) {
    if (product.stockIn > 0) {
      product.quantity += product.stockIn; // Ajouter au stock
      product.stockIn = 0; // Réinitialiser l'entrée
    }
    if (product.stockOut > 0) {
      if (product.stockOut <= product.quantity) {
        product.quantity -= product.stockOut; // Retirer du stock
        product.stockOut = 0; // Réinitialiser la sortie
      } else {
        alert('Impossible de retirer plus que la quantité disponible.');
        product.stockOut = 0;
      }
    }
    alert(`Stock mis à jour: ${product.quantity} unités pour ${product.name}`);
  }

  // Fonction pour gérer le changement de fichier audio
  onAudioFileChange(event: any, product: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        product.audioUrl = reader.result as string; // Stocker l'URL du fichier audio
      };
      reader.readAsDataURL(file);
    }
  }

  updateProduct(product: any) {
    console.log('Produit mis à jour:', product);
  }

  openstockAdjustInDialog() {
    this.stockAdjustInDialogRef = this.dialog.open(this.stockAdjustInDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  closestockAdjustInDialog() {
    this.stockAdjustInDialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  /*****************************/


  inTheCart(productId){
    return this.cartIDs.includes(productId) ;
  }


  ajouterALaCommande(choosenarticle: any, qtecommande){

    if(Number(choosenarticle.quantity.qteTotal)==0){
      this.showSuccessSnackBar('Stock Epuisé');
      return ;
    } 

    if( Number(this.qtecommandee) > Number(choosenarticle.quantity.qteTotal)){
      this.showSuccessSnackBar('Quantité Saisie Invalide');
      return ;
    }

    if(Number(this.prixEdite)==0){
      this.showSuccessSnackBar('Prix invalide');
      return ;
    }

    choosenarticle.depotConcerne = this.choosedDepot.nomDepot ;


    console.log("Added Article Post Ajout:: ", choosenarticle) ;

    var newArticlePanier = Object.assign({},choosenarticle);

    newArticlePanier.prix = this.prixEdite ; // this.getClientPrice(choosenarticle.prices) ; //Number(choosenarticle.prices.detail) ; 


    this.panier.push(newArticlePanier) ;
    this.allQtsOnCart.push(qtecommande) ;
    localStorage.setItem("panier", JSON.stringify(this.panier) );
    localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;
    this.nbreligne++ ;

    this.ajoutpanier = true ;

    this.cartIDs.push(choosenarticle.id) ;

    this.showSuccessSnackBar('Article ajouté avec succès.');

    //setTimeout(()=>{this.ajoutpanier = false ;}, 2000);
  }




  retirerDeLaCommande(choosenarticle: any){
    let index = this.cartIDs.indexOf(choosenarticle.id) ;
    this.cartIDs.splice(index, 1) ;
    this.panier.splice(index, 1) ;
    this.allQtsOnCart.splice(index, 1) ;
    localStorage.setItem("panier", JSON.stringify(this.panier) );
    localStorage.setItem("qteOnCart", JSON.stringify(this.allQtsOnCart) ) ;
    this.nbreligne-- ;
    this.showSuccessSnackBar('Article Retiré.');
  }


  reinitialiser(){
    this.choosedACustomer = false ;
    this.leClient = undefined ;
    this.panier = [] ;
    this.allQtsOnCart = [] ;
    this.nbreligne =  0;
    this.cartIDs = [] ;
    localStorage.removeItem("panier") ;
    localStorage.removeItem("qteOnCart") ;   

  }

  currentPricingType = "" ;

  getClientPrice(allPrices){

    if(this.leClient.pricingType=='Gros'){
      this.currentPricingType = "gros" ;
      return allPrices.gros ;
    }
    if(this.leClient.pricingType=='Demi-Gros'){
      this.currentPricingType = "demiGros" ;
      return allPrices.demiGros ;
    }

    this.currentPricingType = "detail" ;
    return allPrices.detail ;
  }


  formatMoney(montant: any){
    let dollarUSLocale = Intl.NumberFormat('fr-FR');
    return dollarUSLocale.format(montant) ;
  }


  mettreAjourPrixArticleBi(){
    console.log("choosenElt: ", this.choosenElt) ;

    let prixDeVente = this.choosenElt.prices ;
    if(this.leClient.pricingType=='Gros'){
      prixDeVente = { gros: this.prixEdite, demiGros: this.choosenElt.prices.demiGros, detail: this.choosenElt.prices.detail } ;
    }
    if(this.leClient.pricingType=='Demi-Gros'){
      prixDeVente = { gros: this.choosenElt.prices.gros, demiGros: this.prixEdite, detail: this.choosenElt.prices.detail } ;
    }else{
      prixDeVente = { gros: this.choosenElt.prices.gros, demiGros: this.choosenElt.prices.demiGros, detail: this.prixEdite } ;
    }

    this.configServer.mettreAjourPrixArticleBi(this.samacaabiyoonwii, prixDeVente, this.choosenElt).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.unsetPrice = false ;        
        console.log("Mbirr Yi Matna") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }




  opencart(){
    console.log("Asked For the Cart") ;

    if(this.nbreligne === 0){      
      return ;
    }

    const dialogRefCart = this.dialog.open(CartComponent, {
        width: '100%',
        maxWidth: 'unset',
        /*width: '800px',*/
        /*maxWidth: '800px',*/
        height: '100vh',
        disableClose: true,
        data:{"codevendeur": "", "leClient":this.leClient}
      }
    );

    dialogRefCart.afterClosed().subscribe(result0 => {

      console.log("ResultVal after CLose: ", result0) ;

      if(result0=="11"){
        console.log("tHERE BESFORE REINIT: ", result0) ;
        this.reinitialiser() ;
      }else{
        var currentPanier = localStorage.getItem("panier") ;
        var currentQtities =  localStorage.getItem("qteOnCart") ;
        console.log("Panier on Storage!!") ;
        console.log(currentPanier) ;

        this.panier = JSON.parse(currentPanier) ;
        this.allQtsOnCart = JSON.parse(currentQtities) ;
        this.nbreligne = this.panier.length ;

        for (var i = 0; i < this.cartIDs.length; i++) {
          if( !this.PresentDansLePanier(this.cartIDs[i]) ){
            let index = i ;
            this.cartIDs.splice(index, 1) ;            
          }
        }

        /*if(currentPanier!=undefined && currentQtities!=undefined){
          this.panier = JSON.parse(currentPanier) ;
          this.allQtsOnCart = JSON.parse(currentQtities) ;
          this.nbreligne = this.panier.length ;
        }
        else{
          this.panier = [] ;
          this.allQtsOnCart = [] ;
        }*/

        /*
        let deleted = JSON.parse(result0) ;
        for (var i = 0; i < deleted.length; i++) {        
          let index = this.cartIDs.indexOf(deleted[i].id) ;
          this.cartIDs.splice(index, 1) ;
        }*/
      }
    });
  }

  PresentDansLePanier(idArticle){
    for (var i = 0; i < this.panier.length; i++) {
      if(this.panier[i].id==idArticle)
        return true;
    }
    return false ;
  }

  onTabChange(event){

    if(event.index==0)
      this.showpanier = false ;
    else
      this.showpanier = true ;

    setTimeout(() => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > 100) { // Seuil : 100px, tu peux ajuster
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
  }




}
